// import React from "react";
// import "./Blue_border_button.css"
// import { Button } from "react-bootstrap";

// function Blue_border_button({ button_text,onClick }) {
//   return (
//     <>
//     <section className="blue_border_button_holder">

//       <Button className="blue_border_button" onClick={onClick}> {button_text}</Button>
//     </section>
//     </>
//   );
// }

// export default Blue_border_button;

import React from "react";
import "./Blue_border_button.css";
import { Button } from "react-bootstrap";

function Blue_border_button({ button_text, onClick, type = "button" }) {
  return (
    <section className="blue_border_button_holder">
      <Button
        className="blue_border_button"
        onClick={onClick}
        type={type} 
      >
        {button_text}
      </Button>
    </section>
  );
}

export default Blue_border_button;
